import { useState } from 'react';

// State and submit logic for the "Have Questions?" contact form, shared by the
// Visitors and About Us pages so both post to the same endpoint the same way.
export const useQuestionForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success' as 'success' | 'error',
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await fetch('/api/email/submit-question', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-App-Source': 'cogc-ui'
        },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setSnackbar({
          open: true,
          message: 'Question submitted successfully! We will get back to you soon.',
          severity: 'success'
        });
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        throw new Error('Failed to submit question');
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: 'Error submitting question. Please try again later.',
        severity: 'error'
      });
      console.error('Error:', error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  return { formData, handleChange, handleSubmit, submitting, snackbar, handleCloseSnackbar };
};
